/**
 * Estado do detalhe em blocos, lido pelo mapa (goesLayers), pela interface e
 * publicado pelo motor (motor.ts).
 */
import { create } from 'zustand';
import type { ImageWidth } from '../goes/star';
import { LARGURA_BASE, type Nivel } from './blocos';

interface DetalheState {
  /**
   * Nível pedido (null = só a base: afastado, qualidade fixa leve ou sem
   * servidor). Cada produto usa o seu maior nível até este (`nivelDoProduto`).
   */
  nivel: Nivel | null;
  /**
   * Largura da imagem inteira por baixo dos blocos: `LARGURA_BASE` (1800) ou,
   * de perto, com os blocos cobrindo a vista, a menor (`PARAMETROS.basePerto`).
   * O controlador do loop usa esta como teto da base.
   */
  base: ImageWidth;
  /**
   * Blocos à vista baixados / pedidos (nível 1, todos os quadros), bytes
   * baixados e a estimativa (bytes) do que falta, pelo tamanho medido.
   */
  progresso: { baixados: number; total: number; bytes: number; faltam: number };
}

export const PROGRESSO_VAZIO: DetalheState['progresso'] = { baixados: 0, total: 0, bytes: 0, faltam: 0 };

export const useDetalheStore = create<DetalheState>()(() => ({
  nivel: null,
  base: LARGURA_BASE,
  progresso: PROGRESSO_VAZIO,
}));

/**
 * Abertura: enquanto nenhuma base apareceu, o controlador do loop pergunta ao
 * motor a base certa ANTES do primeiro plano — sem isso a abertura pedia a de
 * 1800, e logo depois a de 900 (1,75 MB jogados fora, um pedido cancelado).
 */
let baseDeAbertura: ((produtos: readonly string[]) => void) | null = null;

export function registrarBaseDeAbertura(fn: (produtos: readonly string[]) => void): () => void {
  baseDeAbertura = fn;
  return () => {
    if (baseDeAbertura === fn) baseDeAbertura = null;
  };
}

/** Decide a base da abertura agora (sem efeito sem o motor). */
export function decidirBaseDeAbertura(produtos: readonly string[]): void {
  baseDeAbertura?.(produtos);
}
